import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceService } from 'src/app/services/service.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-tank-inventory',
  templateUrl: './tank-inventory.component.html',
  styleUrls: ['./tank-inventory.component.css']
})
export class TankInventoryComponent implements OnInit {

  dealers: any;
  modalRef: any;
  selectedItem = null;
  selectedDealer = null;
  allowOrderSelection = false;
  tblTanks = null;

  @ViewChild('selectionModalForDetails')
  selectionModalForDetails


  selectedDealerFromBackend


  constructor(private service: ServiceService, private ngModal: NgbModal,
    private utilService: UtilService
  ) { }

  ngOnInit(): void {

    // show loader
    $(".overlay-loading").show();
    let tenantId = JSON.parse(localStorage.getItem("tenantId")) ? JSON.parse(localStorage.getItem("tenantId")).scac : "1"
    this.service.getAssociatedBilltypes().subscribe((data) => {
      $(".overlay-loading").hide();
      console.log("phone books", data);
      if (data && data.length > 0) {
        this.dealers = data[0].dealers;
      }
    }, error => {
      $(".overlay-loading").hide();
      console.error("Error ", error)
    });

  }

  showInventoryDetails(station) {
    console.log("selected station", station);
    this.selectedItem = station;
    this.allowOrderSelection = false;
    this.tblTanks = null;
    this.service.getInventoryDetails(station.locationID).subscribe((data: any) => {
      console.log("inventory details", data);
      this.allowOrderSelection = true;
      this.tblTanks = data?.tblTanks;
      this.tblTanks.forEach(tank => {
        tank.class = this.utilService.selectClass(tank?.displayCode)
      });
    }, error => {
      console.error("Error ", error)
    });
  }


  checkTenantFiltersAvailability() {
  }

}
